module.exports = __webpack_public_path__ + "static/media/qempo-full-active.e036eb28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shopping-cart/qempo-full-active.png
// module id = 396
// module chunks = 0